import { render, staticRenderFns } from "./SSelectArea.vue?vue&type=template&id=92d03050"
import script from "./SSelectArea.vue?vue&type=script&lang=js"
export * from "./SSelectArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports